import * as React from 'react';
import { AppBar, AppBarProps, Title } from 'react-admin';
import { Box } from '@mui/material';
import logo from '../../assets/images/adloot-icon-logo-white.png'; // Adjust the path as necessary
import { CustomUserMenu } from './CustomUserMenu'; // Import the custom user menu

export const CustomAppBar: React.FC<AppBarProps> = props => (
    <AppBar {...props} userMenu={<CustomUserMenu />} sx={{ backgroundColor: '#000' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <Title />
            <Box
            component="img"
            src={logo}
            alt="Ad Loot Logo"
            sx={{ height: 32, ml: 2 }}
        />
        <Box sx={{ flexGrow: 1 }} />
        </Box>
    </AppBar>
);